import React, { Component } from 'react'
import { format, startOfMonth, startOfWeek, endOfMonth, endOfWeek, isSameMonth, 
  addMonths, subMonths, addDays } from 'date-fns'
import axios from 'axios'

import Icon from '@material-tailwind/react/Icon';
import { v4 as uuid } from 'uuid';
import Button from '@material-tailwind/react/Button';
// import {useMonthContext, UpdateMonthContext, UseMonthContext} from "../../providers/state/StateProvider"
function HashDateToID(givenDate) {
  let generatedDate = givenDate.toDateString();
  return generatedDate.replaceAll(' ', '')
}
function CalendarSingleCell(props) {
  let colorIntencityDependingOnNumber = (numberOfPeopleGiven) => {
    let theNumberDerived = 120 - (numberOfPeopleGiven * 20)
    switch(theNumberDerived){
      case (theNumberDerived < 10):
        return theNumberDerived = 10;
      case (theNumberDerived > 90):
        return theNumberDerived = 80
      default:
        return theNumberDerived
    }
  } 
  console.log("hsl(140,25%," + String(colorIntencityDependingOnNumber(props.numberOfPeopleGiven)) + "%)")
  const dateFormat = "d";
  let formattedDate = format(props.day, dateFormat);    
  let thisCellStyle = {
    ...style.calendarCell,
    background: "hsl(140,25%," + colorIntencityDependingOnNumber(props.numberOfPeopleGiven) + "%)",
    border: props.clicked ? "1px solid hsl(140, 25%, 50%)" : "1px solid hsl(140,25%," + colorIntencityDependingOnNumber(props.numberOfPeopleGiven) + "%)"
  }
  if(props.active) { 
    return(
      <div className={"flex-grow "} style={thisCellStyle} key={props.day.toDateString()} onClick={() => {
        return props.onClick(HashDateToID(props.day))
      }} >
            <span className="number p-2 py-3">{format(props.day, dateFormat)}</span>
            <div className="flex flex-wrap m-5">               
                                {/* <div className="cursor-pointer w-full px-4 flex-1">
                                "kuma"
                                </div> */}
            </div>
      </div>
    )
  }
  return (
    <div style={style.calendarCell} className="flex-grow pointer-events-none bg-white" key={props.day.toDateString()}>
    <span className="text-gray-400 number p-2 py-3">{formattedDate}</span>
    </div>
  )
}



export class CalendarWidget extends Component {
    constructor(props) {
      super(props);
      this.state = {
          currentMonth: new Date(),
          selectedDate: new Date(),
          monthObject: {},
          daysFree: props.daysFree ? props.daysFree : {},
          eventId: props.eventId,
          eventFreeDays: {}
        };
    }

    
    GenerateMonthObject = (monthToFill) => {
        let monthObject = {}
        let dayFromStart = startOfMonth(monthToFill);
        const monthEnd = endOfMonth(dayFromStart);
        while(dayFromStart <= monthEnd) {
          monthObject = {
            ...monthObject,
            [uuid()]: {
              date: dayFromStart,
              items: []
            }
          }
          dayFromStart = addDays(dayFromStart, 1);
        }
        return monthObject
        //loop throught all dates in the month and input them into monthObject as objects
      }
      onDateClick = (hashedDay) => {
        let {daysFree} = this.state
        if(!(hashedDay in daysFree)) {
          daysFree[hashedDay] = true
        } else {
          delete daysFree[hashedDay]
        }
        this.setState({daysFree: daysFree})

      };
    
      nextMonth = () => {
        let newMonth = addMonths(this.state.currentMonth, 1);
        this.setState({
          currentMonth: newMonth,
          monthObject: this.GenerateMonthObject(newMonth)
        });

      };
    
      prevMonth = () => {
        let newMonth = subMonths(this.state.currentMonth, 1);
        this.setState({
          currentMonth: newMonth, 
          monthObject: this.GenerateMonthObject(newMonth)
        });
      };
      onSubmit = () => {
        let {daysFree} = this.state
        //fecth the event from db
        return this.props.onSubmit(daysFree)
        //loop throught daysFree and for every day in daysFree, increment the count + 1 in db. 
        //rewrite the db daysFree
      }
      

      //RENDERING FUNCTIONS      
      renderHeader() {
        const dateFormat = "MMMM yyyy";
    
        return (
          <div style={style.calendarHeader} className="flex flex-wrap block w-full border-b">
            <div className="w-full px-4 flex-1 text-left">
              <div className="cursor-pointer" onClick={this.prevMonth}>
              <Icon name="arrow_left" size="xl" />
              </div>
            </div>
            <div className="w-8/12 px-4 flex-1 text-center">
                <div className="cursor-pointer py-1">
                    <span>{format(this.state.currentMonth, dateFormat)}</span>
                </div>
            </div>
            <div className="w-full px-4 flex-1 text-right" onClick={this.nextMonth}>
              <div className="cursor-pointer">
              <Icon name="arrow_right" size="xl" />

              </div>
            </div>
          </div>
        );
      }
      //Write Mon, Tue and ETC
      renderDays() {
        const days = [];
        const daysOfWeek = ["Sun", "Mon", "Tue",  "Wed", "Thu", "Fri", "Sat"]
    
        for (let i = 0; i < 7; i++) {
          days.push(
            <div className="flex-grow text-center text-blueGray-300" key={i}>
              <span>{daysOfWeek[i]}</span>
            </div>
          );
        }
    
        return <div className="bg-white border-b py-2 flex flex-row">{days}</div>;
      }
    
      renderCells = () => {
        const { currentMonth, daysFree, eventFreeDays } = this.state;
        const monthStart = startOfMonth(currentMonth);
        const monthEnd = endOfMonth(monthStart);
        const startDate = startOfWeek(monthStart);
        const endDate = endOfWeek(monthEnd);
        const rows = [];
    
        let days = [];
        let day = startDate;



        console.log(eventFreeDays)
        while (day <= endDate) {
          for (let i = 0; i < 7; i++) {
            let calendarDay, CellIntencity;
            let theNumberOfPeopleGoingInThisDate = 0
            if(HashDateToID(day) in eventFreeDays) {
              theNumberOfPeopleGoingInThisDate = eventFreeDays[HashDateToID(day)].length
            }
            calendarDay = <CalendarSingleCell numberOfPeopleGiven={theNumberOfPeopleGoingInThisDate} CellIntencity={CellIntencity} clicked={HashDateToID(day) in daysFree ? true : false} 
                            active={isSameMonth(day, monthStart) ? true: false} day={day} onClick={this.onDateClick}/>
            days.push(calendarDay);
            day = addDays(day, 1);
          }
            rows.push(
              <div className="" style={style.calendarRow} key={day}>
                {days}
              </div>
            );
          days = [];
        }
        return <div className="body">{rows}</div>;
      }

      componentDidMount = async() => {
        let eventFromDb = await axios.post(process.env.REACT_APP_API + "/events/get-one", {id:this.state.eventId});
        this.setState({eventFreeDays: eventFromDb.data.daysFree})

      }
    
    
    
      render() {
          
          return (
            <div className="container max-w-7x1 px-4 my-5 bg-white mx-auto rounded">
            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-xl -mt-64 text-xs">            
            {this.renderHeader()}
            {this.renderDays()}
            {this.renderCells()}
            </div>
            <div className>
            <Button onClick={this.onSubmit}>Submit</Button>
           </div>
          </div>
        );
      }
  }

const style = {
  calendarHeader: {
    padding: "1em 0", 
    background: "#fff"
  },
  calendarCell: {
    position: "relative",
    height: "3.5em",
    flexBasis: 0,
    maxWidth: "100%",
    borderRight: "0.5px solid #eee",
    borderBottom: "0.5px solid #eee",
    overflow: "hidden",
    cursor: "pointer",
    transition: "0.25s ease-out"
  },
  calendarRow: {
    margin: "0", 
    padding: "0", 
    display: "flex", 
    flexDirection: "row", 
    flexWrap: "wrap", 
    width: "100%"
  }
}
export default CalendarWidget

